<template>
  <div
    :class="[
      'new-top-bar-wrapper',
      {
        expanded: expanded,
      },
    ]"
  >
    <slot name="top" />
    <slot name="center" />
    <slot name="bottom" />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    expanded: {
      type: Boolean,
    },
  },
});
</script>

<style lang="scss" scoped>
@import '../scss/dsr-variables';

.new-top-bar-wrapper {
  height: fit-content;
  gap: var(--spacing-100);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-50) var(--spacing-100);
  box-shadow: var(--shadow-1);
  background: var(--white);
  position: relative;
  width: 100vw;

  @media screen and (max-width: $sm) {
    gap: 0;
    padding: 0;

    &.expanded {
      height: 100vh;
      justify-content: flex-start;
    }
  }
}
</style>
